export const navigateReactUrl = (initPath: any, path: any) => {
  return window.open(`${initPath}${path}`, '_blank')
}
